<template>
  <div>
    <b-card>
      <p class="lead mb-0">{{ trans('gift_cards') }}</p>
      <p v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-else-if="!items || items.length == 0" class="text-muted">{{ trans('no_gift_cards') }}</p>
      <p v-else class="text-muted">{{ trans('touch_card_to_flip') }}</p>
      <b-row v-for="gift_card in items" :key="gift_card.no_display" class="mb-3">
        <b-col class="col-12 col-md-8 col-lg-6 col-xl-5">
          <gift-card
            :organization="organization"
            :gift_card="gift_card"
          ></gift-card>
        </b-col>
        <b-col class="col-12 col-md-4 col-lg-6 col-xl-7">
          <b-row class="mb-3">
            <b-col>
              <b-button variant="outline-branded" size="sm" @click="onClickShowLogs(gift_card)" :disabled="busy">
                <i class="fa fa-fw fa-eye"></i>
                {{ trans('log') }}
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button variant="outline-branded" size="sm" @click="onClickShowTransferModal(gift_card)" :disabled="busy">
                <i class="fa fa-gift"></i>
                {{ trans('transfer') }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div v-if="emptyCount > 0" class="mt-4 text-center">
        <b-button variant="link" @click="show_empty = ! show_empty">
          {{ trans('empty_cards') }} ({{ emptyCount }})
          <i :class="`fa fa-fw fa-caret-${show_empty ? 'up' : 'down'}`"></i>
        </b-button>
      </div>
      <br/>
    </b-card>
    <b-card v-if="gift_card_logs && gift_card_logs.length > 0" class="mt-2">
      <p class="lead mb-2">{{ trans('transfered_gift_cards') }}</p>
      <gift-cards-client-logs-table
        :organization="organization"
        :logs="gift_card_logs"
      ></gift-cards-client-logs-table>
      <small class="text-muted"><i class="fa fa-fw fa-info-circle"></i> {{ trans('gift_transfer_error') }}</small>
    </b-card>
    <b-modal
      id="show-gift-card-logs"
      :title="showLogsModalTitle"
      :ok-title="trans('close')"
      size="lg"
      ok-only
    >
      <gift-card-logs-table
        v-if="!!gift_card"
        :organization="organization"
        :gift_card="gift_card"
      ></gift-card-logs-table>
    </b-modal>
    <gift-card-transfer-modal
      :organization="organization"
      :gift_card="gift_card"
      @transfered="reloadTable()"
    ></gift-card-transfer-modal>
  </div>
</template>

<script>
  import GiftCard from './../gift-card/GiftCard'
  import Dollar from './../billing/Dollar'
  import GiftCardLogsTable from './../gift-card/GiftCardLogsTable'
  import GiftCardTransferModal from '../gift-card/GiftCardTransferModal'
  import GiftCardsClientLogsTable from '../gift-card/GiftCardsClientLogsTable'

  export default {
    props: {
      organization: Object,
    },
    components: {
      GiftCard,
      Dollar,
      GiftCardLogsTable,
      GiftCardTransferModal,
      GiftCardsClientLogsTable
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        iframeUrlPrefix: _.iframeUrlPrefix,
        busy: false,
        error: null,
        show_empty: false,
        gift_cards: null,
        gift_card: null,
        gift_card_logs: null,
      }
    },
    computed: {
      items() {
        let empty = []
        let gift_cards = _.reduce(this.gift_cards || [], (gift_cards, gift_card) => {
          if (gift_card.balance > 0) gift_cards.push(gift_card)
          else empty.push(gift_card)
          return gift_cards
        }, [])
        return this.show_empty ? _.union(gift_cards, empty) : gift_cards
      },
      emptyCount() {
        return _.reduce(this.gift_cards || [], (count, gift_card) => {
          if (gift_card.balance == 0) count += 1
          return count
        }, 0)
      },
      showLogsModalTitle() {
        if (!this.gift_card) return null
        return trans('gift_card') + ' #' + this.gift_card.no_display
      },
    },
    methods: {
      onClickShowLogs(gift_card) {
        this.gift_card = gift_card
        this.$bvModal.show('show-gift-card-logs')
      },
      onClickShowTransferModal(gift_card) {
        this.gift_card = gift_card
        this.$bvModal.show('gift-card-transfer-modal')
      },
      fetch() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/gift_cards`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.gift_cards = response.data.gift_cards
          this.gift_card_logs = response.data.gift_card_logs
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.gift_cards = []
        })
      },
      reloadTable() {
        this.fetch()
      },
    },
    mounted() {
      window.myGiftCards = this
      if (!this.gift_cards) this.fetch()
    },
  }
</script>